'use client'

import { PortalMotionStyles, ScrollProgressBar } from '@/app/components/portal/PortalMotionStyles'

/**
 * The atmosphere the candidate portal set (Mark, 2026-08-01): the navy field,
 * a drifting gold aurora, paper grain, the gold scroll rule, and the genuine
 * compass glyph from the logo turning slowly behind the page. The same motion
 * system as the portal, so the two surfaces read as one brand.
 */
export function SiteChrome() {
  return (
    <>
      <PortalMotionStyles />
      <ScrollProgressBar />
      <div className="mp-aurora" aria-hidden="true" />
      <div className="mp-grain" aria-hidden="true" />
      <div
        className="pointer-events-none"
        style={{
          position: 'fixed',
          width: 'min(140vw, 1040px)',
          height: 'min(140vw, 1040px)',
          top: '42%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          opacity: 0.06,
          zIndex: 0,
        }}
        aria-hidden="true"
      >
        <div className="mp-compass h-full w-full">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/meridian-compass-mark.svg" alt="" className="h-full w-full" />
        </div>
      </div>
    </>
  )
}

/** Rise-on-scroll for a column's direct children (the portal's reveal). */
export { useRevealColumn } from '@/app/components/portal/PortalMotionStyles'
